const teIN= {
    login: {
      title: 'సైన్-ఇన్ చేయండి',
      sign_in_btn: 'సైన్-ఇన్ చేయండి'
    },
    bar: {
        logout: 'లాగ్ అవుట్ చేయండి',
        languages: 'భాషలు',
        settings: 'సెట్టింగ్‌లను తెరవండి'
    },
    language: {
      name: 'ఇంగ్లీషు (యుఎస్)',
    },
    attributePage: {
        title: 'లక్షణాలలో మార్పులు',
        viewChanges: 'మార్పులను చూడండి',
        dateTime: 'తేదీ',
        notificationType: 'నోటిఫికేషన్ రకం',
        notificationValue: 'నోటిఫికేషన్ విలువ',
        oldValue: 'పాత విలువ',
        newValue: 'కొత్త విలువ',
        accept: 'అంగీకరించండి',
        reject: 'తిరస్కరించండి',
    },
    Home: 'హోమ్',
    load: 'ప్రారంభ లోడ్‌ను అమలు చేస్తోంది...',
    Requested: "అభ్యర్థించింది",
    Viewed: "వీక్షించారు",
    Executing: "అమలు చేస్తున్నది",
    Completed: "పూర్తి చేసింది",
    Expired: "గడువు ముగిసింది",
    Cancelled: "రద్దు చేయబడింది",
    Error: "దోషం",
    Rejected: "తిరస్కరించబడింది",
    error: 'ఏదో తప్పు జరిగింది; దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.',
    displayname: 'డిస్‌ప్లే పేరు',
    givenname: 'పేరు',
    surname: 'ఇంటి పేరు',
    email: 'ఇమెయిల్',
    mail: 'ఇమెయిల్',
    name: 'పేరు',
    firstname: 'పేరు',
    lastname: 'ఇంటి పేరు',
    footer_copyright: 'అన్ని హక్కులు రిజర్వ్ చేయబడ్డాయి.'
  };
  
  export default teIN;
  